export { forBusiness_beauty_challenges } from './challagesData';
export { forBusiness_beauty_essential } from './essentialData';
export { forBusiness_beauty_elevates } from './elevatesData';
export { forBusiness_beauty_create } from './createData';
export { forBusiness_beauty_tips } from './tipsData';
export { forBusiness_beauty_perfect } from './perfectData';
